module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/redo.e08f61fb.svg";